"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBListItem = require("./HBListItem.styles");
var _HBListItem2 = require("./HBListItem.constants");
var _HBActionArea = _interopRequireWildcard(require("../accessibility/HBActionArea"));
var _useTestId = require("../common/internal/useTestId");
var _excluded = ["prefix", "suffix", "textSuffix", "hoverAction", "subtext", "children", "selected", "theme", "size", "rounded", "disabled", "id", "onClick", "data-testid"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBListItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _containerProps$data, _containerProps$data2, _containerProps$data3;
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    textSuffix = _ref.textSuffix,
    hoverAction = _ref.hoverAction,
    subtext = _ref.subtext,
    children = _ref.children,
    selected = _ref.selected,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'neutral' : _ref$theme,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? true : _ref$rounded,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    id = _ref.id,
    onClick = _ref.onClick,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'hb-list-item' : _ref$dataTestid,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var getTestId = (0, _useTestId.useTestId)(dataTestId);
  var _theme = disabled ? 'disabled' : theme;
  var currTheme = _HBListItem2.THEME[_theme];
  var textType = currTheme.textTypes[size];
  var _useActionArea = (0, _HBActionArea.useActionArea)({
      enabled: Boolean(onClick),
      id: id,
      onClick: onClick,
      disabled: disabled
    }),
    actionAreaProps = _useActionArea.actionAreaProps,
    containerProps = _useActionArea.containerProps;
  return /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemContainer, (0, _extends2["default"])({
    ref: ref,
    theme: _theme,
    selected: selected,
    "data-disabled": (_containerProps$data = containerProps['data-disabled']) !== null && _containerProps$data !== void 0 ? _containerProps$data : null,
    "data-interactive": (_containerProps$data2 = containerProps['data-interactive']) !== null && _containerProps$data2 !== void 0 ? _containerProps$data2 : null,
    "data-focus-visible": (_containerProps$data3 = containerProps['data-focus-visible']) !== null && _containerProps$data3 !== void 0 ? _containerProps$data3 : null,
    "data-selected": selected !== null && selected !== void 0 ? selected : null,
    "data-size": size,
    "data-rounded": rounded || null,
    onClick: function onClick(e) {
      var _actionAreaProps$ref;
      e.stopPropagation();
      (_actionAreaProps$ref = actionAreaProps.ref) === null || _actionAreaProps$ref === void 0 || (_actionAreaProps$ref = _actionAreaProps$ref.current) === null || _actionAreaProps$ref === void 0 || _actionAreaProps$ref.click();
    }
  }, getTestId(), props), Boolean(onClick) && /*#__PURE__*/_react["default"].createElement(_HBActionArea["default"], (0, _extends2["default"])({}, actionAreaProps, getTestId('action-area'), selected !== undefined && {
    'aria-pressed': selected
  })), /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemInnerContainer, (0, _extends2["default"])({
    rounded: rounded,
    size: size,
    withSubtext: !!subtext
  }, getTestId('inner-container'), containerProps), prefix && /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemSideElement, getTestId('prefix'), prefix), /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemContentWrapper, getTestId('content-wrapper'), /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemContent, getTestId('content'), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: textType,
    color: currTheme.color
  }, children), subtext && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: textType,
    color: disabled ? 'textDisabled' : 'textSecondary'
  }, subtext)), textSuffix && /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemTextSuffix, getTestId('text-suffix'), textSuffix)), hoverAction && /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemHoverAction, getTestId('hover-action'), hoverAction), suffix && /*#__PURE__*/_react["default"].createElement(_HBListItem.ListItemSideElement, getTestId('suffix'), suffix)));
});
var _default = exports["default"] = HBListItem;
//# sourceMappingURL=HBListItem.js.map